export default {
  emailAddress: "sogang@acmicpc.team",
  kakaoPfUrl: "https://pf.kakao.com/_xewSPK",
  fullAddress:
    "04107 서울시 마포구 백범로 35 (신수동) 서강대학교 김대건관(K관) 512호",
};
